import React from 'react';
import Step from '@material-ui/core/Step';
import { withStyles } from '@material-ui/styles';

const RetailStep5 = withStyles((theme) => ({
  root: {
    '& .MuiStepLabel-iconContainer': {
      backgroundColor: '#F7F8FA',
      zIndex: 1000,
    },
    '&:first-child': {
      marginLeft: 'calc(-100% / 7)',
      [theme.breakpoints.up('sm')]: {
        marginLeft: 'calc(-100% / 9.5)',
      },
    },
    '&:last-child': {
      marginRight: 'calc(-100% / 7)',
      [theme.breakpoints.up('sm')]: {
        marginRight: 'calc(-100% / 9.5)',
      },
    },
    '&:first-child > span > span:last-child': {
      marginLeft: 'calc(100% - 30px)',
    },
    '&:last-child > span > span:last-child': {
      marginRight: 'calc(100% - 30px)',
    },
    '&:first-child > span > span:last-child > span': {
      textAlign: 'left',
    },
    '&:last-child > span > span:last-child > span': {
      textAlign: 'right',
    },
  },
}))(Step);

export default RetailStep5;
